module.exports = __webpack_public_path__ + "img/State=14.5c318d2c.svg";